/*
 * @Author: your name
 * @Date: 2021-01-04 11:19:29
 * @LastEditTime: 2021-06-30 11:38:39
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \yellow-member-admin\src\utils\util.js
 */
import Vue from 'vue'

const utils = {

  /**
   * 传入一个对象，对象的属性作为参数键，对象属性的值作为参数值，返回对应FormData
   * @param paramObj
   */
  formDataFactory(paramObj) {
    if (!paramObj) {
      paramObj = {}
    }
    let data = new FormData()
    Object.keys(paramObj).forEach(key => data.append(key, paramObj[key]))
    return data
  },
  getDate() {
    return new Date(+new Date() + 8 * 3600 * 1000)
      .toJSON()
      .substr(0, 19)
      .replace("T", " ");
  },
  RetnW() {//JS的数组
    var date = new Date();
    var day = date.getDay();
    var weeks = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
    var week = weeks[day];
    return week
  }
}

/** TablePage 等组件依赖：根据视口计算 el-table 的 height */
const myUtils = {
  tableHeight(vm, topReserve) {
    const h = document.documentElement.clientHeight || window.innerHeight || 600
    const reserve = typeof topReserve === 'number' && topReserve >= 0 ? topReserve : 255
    const tableH = h - reserve
    vm.height = tableH > 150 ? tableH : 150
  }
}

export default utils
Vue.prototype.$utils = utils
Vue.prototype.myUtils = myUtils
